'use strict'

import ApiClient from './ApiClient'

export default class PvPinRepository {
  /**
   * サイドメニューの現在のピン留め位置を取得します
   * @param pinned ピン留め位置
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/personal-settings/pin`)
  }

  /**
   * サイドメニューの現在のピン留め位置を更新します
   * @param pinned ピン留め位置
   * @returns {*}
   */
  put (pinned) {
    return ApiClient().put(`/personal-settings/pin`, { pinned })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/PvPinRepository.js